let evEmitter = require('./../modules/events');
import Trackers from './tracker/tracker';
const trackers = new Trackers();
jQuery(function($) {
    /**
     * Добавляет товар в избранное, необходимо передавать data-аттрибут product-id с ИД товара
     */
    $('body').on('click', '.js-add-favorite', function(e) {
        var $selectorFavorite = $(this);
        e.preventDefault();
        $.ajax({
            url: '/ajax/action/favorite/add/',
            data: 'PRODUCT_ID=' + $(this).data('product-id'),
            success: function(result) {
                //Закрашиваем сердечки
                if (result.code === 200) {
                    //Для списка товаров
                    if ($selectorFavorite.hasClass('heart') && $selectorFavorite.hasClass('product__fav')) {
                        $selectorFavorite.addClass('heart--active');
                        $selectorFavorite.addClass('product__fav--active');
                        $selectorFavorite.addClass('js-remove-favorite');
                        $selectorFavorite.removeClass('js-add-favorite');
                    } else {
                        //Для карточки товара
                        $('span.heart').addClass('heart--active');
                        $('span.heart').addClass('js-remove-favorite');
                        $('span.heart').removeClass('js-add-favorite');
                        $('.product-card__top span.product-card__fav').removeClass('js-add-favorite');
                        $('.product-card__top span.product-card__fav').addClass('js-remove-favorite');
                    }
                    trackers.onAddToFav({
                        fbpixel: {
                            value: parseInt(
                                document.querySelector('.product-card__price-value').textContent.replace(' ', '')
                            )
                        }
                    });
                    let list = document.getElementsByClassName('breadcrumbs__text');
                    trackers.onPMbtnFavorite({param:Array.from(list).slice(-1)[0].innerHTML});
                    evEmitter.emitEvent('addToFavorites');
                } else if (result.code === 403) {
                    //Показываем окно авторизации
                    $('.js-jqi-show-login').trigger('click');
                }
            }
        });
    });

    /**
     * Убирает товар из избранного, необходимо передавать data-аттрибут product-id с ИД товара
     */
    $('body').on('click', '.js-remove-favorite', function(e) {
        var $selectorFavorite = $(this);
        e.preventDefault();
        $.ajax({
            url: '/ajax/action/favorite/remove/',
            data: 'PRODUCT_ID=' + $(this).data('product-id'),
            success: function(result) {
                //Закрашиваем сердечки
                if (result.code === 200) {
                    //Для списка товаров
                    if (
                        $selectorFavorite.hasClass('heart--active') &&
                        $selectorFavorite.hasClass('product__fav--active')
                    ) {
                        $selectorFavorite.removeClass('heart--active');
                        $selectorFavorite.removeClass('product__fav--active');
                        $selectorFavorite.removeClass('js-remove-favorite');
                        $selectorFavorite.addClass('js-add-favorite');
                    } else {
                        //Для карточки товара
                        $('span.heart').removeClass('heart--active');
                        $('span.heart').removeClass('js-remove-favorite');
                        $('span.heart').addClass('js-add-favorite');
                        $('.product-card__top span.product-card__fav').addClass('js-add-favorite');
                        $('.product-card__top span.product-card__fav').removeClass('js-remove-favorite');
                    }
                }
            }
        });
    });
});



// WEBPACK FOOTER //
// ./blocks/heart.js